import { Dayjs, dayjs, formatAmount } from "@synota-io/synota-shared-ui";

export function getHoursSinceDate(date: Dayjs | undefined | null | void) {
  if (!date) {
    return 0;
  }
  const now = dayjs();
  const pastDate = dayjs(date);
  const diffInHours = now.diff(pastDate, "hour");

  return diffInHours;
}

export function formatHoursSinceDate(date: Dayjs | undefined | null | void, hours?: number) {
  if (!date) {
    return null;
  }
  const diffInHours = hours || getHoursSinceDate(date);

  if (diffInHours < 1) {
    return "Less than an hour ago";
  }

  if (diffInHours <= 48) {
    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  }

  return date.fromNow();
}

export function delaySecondsToHours(seconds: number) {
  if (!seconds) {
    return "-";
  }

  if (seconds < 3600) {
    const minutes = seconds / 60;
    return `${formatAmount(minutes)} minute${minutes > 1 ? "s" : ""}`;
  }

  const hours = seconds / 60 / 60;
  return `${formatAmount(hours)} hour${hours > 1 ? "s" : ""}`;
}
